import React from 'react';
import { Navigate } from 'react-router-dom';
import HomePage from './Landing/HomePage';

/**
 * RootRoute Component
 * 
 * This component handles the root path ("/") and ensures HomePage is ALWAYS shown
 * for unauthenticated users. Only redirects to dashboard if user is explicitly authenticated.
 * 
 * CRITICAL: This component should NEVER redirect to /signin. HomePage is the default.
 */
const RootRoute = ({ isAuthenticated, user, loading, getDashboardRoute }) => {
  // CRITICAL CHECK: If no token exists, immediately show HomePage (no checks)
  const token = localStorage.getItem('token');
  if (!token) {
    return <HomePage />;
  }

  // During loading, show HomePage immediately (no waiting)
  if (loading) {
    return <HomePage />;
  }

  // ONLY redirect if explicitly authenticated with valid user AND role
  // This is the ONLY condition that should cause a redirect away from HomePage
  if (isAuthenticated && user && user.role) {
    const route = getDashboardRoute(user);
    return <Navigate to={route} replace />;
  }

  // DEFAULT: Always show HomePage
  // This includes:
  // - Not authenticated
  // - No user object
  // - Invalid/expired token
  // - Any other condition
  return <HomePage />;
};

export default RootRoute;
